module.exports = __webpack_public_path__ + "img/Ye_Grace_Chen.2812127f.jpg";